/**
 * More from Birdie Glide Slider
 * Replaces custom swiper with Glide.js implementation
 */

let glideInstance = null;
let isInitialized = false;
let retryCount = 0;
const MAX_RETRIES = 50;
const RETRY_DELAY = 200;

function getSlideCount() {
  const slider = document.querySelector('.more-from-birdie__slider');
  if (!slider) return 0;
  return slider.querySelectorAll('.glide__slide').length;
}

function shouldInitializeSlider() {
  const slideCount = getSlideCount();
  const isMobile = window.innerWidth <= 749;
  const isDesktop = window.innerWidth >= 750;
  
  // Always initialize on mobile if there are slides
  if (isMobile && slideCount > 0) {
    return true;
  }
  
  // On desktop, only initialize if there are more than 3 slides
  if (isDesktop && slideCount > 3) {
    return true;
  }
  
  return false;
}

function destroySlider() {
  if (glideInstance) {
    glideInstance.destroy();
    glideInstance = null;
    isInitialized = false;
    
    // Remove glide class to enable fallback styles
    const moreFromBirdieSlider = document.querySelector('.more-from-birdie__slider');
    if (moreFromBirdieSlider) {
      moreFromBirdieSlider.classList.remove('glide');
    }
    
  }
}

function enableFallbackLayout() {
  const moreFromBirdieSlider = document.querySelector('.more-from-birdie__slider');
  if (moreFromBirdieSlider) {
    moreFromBirdieSlider.classList.remove('glide');
  }
}

function initializeSlider() {
  if (isInitialized || !shouldInitializeSlider()) {
    return;
  }

  // Check if Glide is available with retry limit
  if (typeof Glide === 'undefined') {
    if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(initializeSlider, RETRY_DELAY);
    } else {
      enableFallbackLayout();
    }
    return;
  }
  
  const moreFromBirdieSlider = document.querySelector('.more-from-birdie__slider');
  if (!moreFromBirdieSlider) {
    if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(initializeSlider, RETRY_DELAY);
    } else {
      enableFallbackLayout();
    }
    return;
  }
  
  try {
    const slideCount = getSlideCount();
    const isMobile = window.innerWidth <= 749;
    
    // Add glide class to enable slider styles
    moreFromBirdieSlider.classList.add('glide');
    
    const config = {
      type: 'slider',
      startAt: isMobile ? 1 : 0, // Start at second slide on mobile, first on desktop
      perView: isMobile ? 1 : 3,
      gap: 20,
      peek: {
        before: 60,
        after: 60
      },
      animationDuration: 600,
      keyboard: false,
    };
    
    glideInstance = new Glide(moreFromBirdieSlider, config);
    
    glideInstance.on('mount.after', function() {
      retryCount = 0; // Reset retry count on successful mount
    });
    
    glideInstance.on('run', function() {
    });
    
    glideInstance.mount();
    isInitialized = true;
    
  } catch (error) {
    enableFallbackLayout();
  }
}

function handleResize() {
  const shouldInit = shouldInitializeSlider();
  
  if (shouldInit && !isInitialized) {
    initializeSlider();
  } else if (!shouldInit && isInitialized) {
    destroySlider();
  } else if (isInitialized && shouldInit) {
    // Reinitialize with new settings if screen size changed
    destroySlider();
    setTimeout(initializeSlider, 100);
  }
}

// Wait for Glide library and DOM to be ready
function waitForGlideAndInit() {
  let attempts = 0;
  const maxAttempts = 50; // 10 seconds max wait time for dynamic content
  
  function checkAndInit() {
    attempts++;
    
    if (typeof Glide !== 'undefined') {
      const slider = document.querySelector('.more-from-birdie__slider');
      if (slider) {
        initializeSlider();
        return;
      }
    }
    
    // Retry if we haven't exceeded max attempts
    if (attempts < maxAttempts) {
      setTimeout(checkAndInit, RETRY_DELAY);
    } else {
      enableFallbackLayout();
    }
  }
  
  checkAndInit();
}

// Start initialization
waitForGlideAndInit();

// Also listen for dynamic content changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node contains our slider
          if (node.querySelector && node.querySelector('.more-from-birdie__slider')) {
            // Reset retry count for new content
            retryCount = 0;
            setTimeout(initializeSlider, RETRY_DELAY);
          }
          // Also check if the node itself is our slider
          if (node.classList && node.classList.contains('more-from-birdie__slider')) {
            // Reset retry count for new content
            retryCount = 0;
            setTimeout(initializeSlider, RETRY_DELAY);
          }
        }
      });
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Handle window resize
window.addEventListener('resize', () => {
  clearTimeout(window.resizeTimeout);
  window.resizeTimeout = setTimeout(handleResize, 250);
});

// Manual trigger function for dynamic content
window.initMoreFromBirdieSlider = function() {
  setTimeout(initializeSlider, 100);
};

// Export for external use
window.MoreFromBirdieSlider = {
  init: initializeSlider,
  destroy: destroySlider,
  isInitialized: () => isInitialized
};